import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';
import StageHeader from '../../components/stageHeader';
import Datepicker from 'vuejs-datepicker';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './reviewPickupRequest.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import PayMethod from '../../components/payMethod';
import tmsService from '../../services/axios/tmsService';
import tmsTransformRequestService from '../../services/axios/tmsTransformRequestService';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import qs from 'qs';
import localStorageUtil from '../../services/localStorageUtil/localStorageUtil';
import AddPayment from '../../components/addPayment';
import { forEach, clone, map, isString, isNumber, round } from 'lodash-es';
import PayPal from 'vue-paypal-checkout';
import switchBillingToService from '../../shared/switchBillingToService';
import util from '../../shared/util';
Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate']);
@Component({
    mixins: [template],
    components: {
        Datepicker,
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        PayMethod,
        AddPayment,
        PayPal,
    },
})
export default class ReviewPickupRequest extends Vue {
    truckloadForm: any = {};
    aaa: any = '23';
    aab: any = '';
    freightChargesBillTo: any = 3;
    editProductModal: string = 'shipmentConfirmed';
    editDetals: any = {
        Pickup: false,
        Delivery: false,
        Invoice: false,
    };
    quoteInfo: any = {};
    quoteId: any = '';
    orderParams: any = {};
    showErrTip: boolean = false;
    transactionFee: boolean = false;
    errorText: String = '';
    canPlaceOrder: Boolean = true;
    acceptService: Boolean = false;
    isPayPal: Boolean = false;
    orderId: any = '';
    tipType: string = '';
    pickupService: any = '';
    deliveryService: any = '';
    refreshPaymethodList: Boolean = false;
    billing: any = {};
    selectPayMent: any = {};
    userSource: any = false;
    billToId: any = '';
    payMethod: any = '';
    payment: any = '';
    isAcceptTermsofService: Boolean = false;
    preisDraft: Boolean = false;
    invoice_id_ary: any = [];
    paymentList: Array<any> = [];
    paymentMethodType: any = '';
    totalBalance: any = 0;
    list: any = [];
    creditAmount: any = 0;
    totalBalanceByCredit: any = 0;
    private shipperAddress: any = {};
    credentials: any = {};
    buttonStyle: any = {
        label: 'pay',
        size: 'responsive',
        shape: 'rect',
        color: 'gold',
    };

    env: String = '';
    transactionTotalAmount: any = null;
    chargeOther: any = null;
    paymentMethod: any = {};

    @Watch('payMethod', { deep: true })
    watchPayMethod(val: any, oldVal: any) {
        if (val.payment_method == 'Paypal' || val.payment_method == 'CC') {
            this.chargeOther = this.toFixedValue(
                (this.quoteInfo.total_amount * 105) / 100 - this.quoteInfo.total_amount,
                2
            );
            this.transactionTotalAmount = this.toFixedValue(
                (this.quoteInfo.total_amount * 105) / 100,
                2
            );
        } else {
            this.chargeOther = null;
            this.transactionTotalAmount = null;
        }
    }
    async created() {
        this.quoteId = this.$route.params.id;
        await this.getCustomerInfo();
        this.getQuoteInfoFromStorage();

        // this.getWarehouse();
    }

    async mounted() {
        await util.onSameAsAddress({ quoteId: this.quoteId }).then((res: any) => {
            this.shipperAddress = res;
        });
    }

    getPayPalClientId() {
        tmsServiceBackend.get(`/paypal/client`).then(
            (res: any) => {
                this.env = res.data.data.env;
                if (this.env == 'sandbox') {
                    this.credentials.sandbox = res.data.data.client_id;
                } else {
                    this.credentials.production = res.data.data.client_id;
                }
            },
            (err: any) => {
                this.showErrorFun(err.response.data.message);
            }
        );
    }

    editProductAction(index: any) {}
    getPaymentList(billToId: any) {
        tmsServiceBackend
            .post(`/payment/getPaymentMethodList?billto_id=${billToId}&create_from=CLIENT`)
            .then(
                (res: any) => {
                    this.paymentList = res.data.data;
                },
                (err: any) => {
                    console.log(err);
                }
            );
    }

    getCustomerInfo() {
        switchBillingToService.post().then((res: any) => {
            if (res.data.billing) {
                this.billing = res.data.billing;
                this.billToId = res.data.billing.location_id;
                this.getPaymentList(res.data.billing.location_id);
                this.getPayPalClientId();
                if (
                    res.data.billing.location_payment_type &&
                    res.data.billing.location_payment_type == 'deposit'
                )
                    this.userSource = true;
            }
        });
    }

    closeModal() {
        this.$modal.hide(this.editProductModal);
        this.$router.push({
            name: 'shipment',
        });
    }

    saveProduct() {
        // this.validate();
    }
    selectItem(item: any) {}

    getQuoteInfoFromStorage() {
        this.orderParams = localStorageUtil.getItemFromStorage('schedukeAPickup') || {};
        if (!this.orderParams.quoteId) {
            this.canPlaceOrder = false;
            this.showErrorFun('Quote params error.');
        } else {
            this.getQuoteInfo();
        }
    }

    getQuoteInfo() {
        tmsService
            .post(`/write_new/get_tms_quote_line.php`, qs.stringify({ quote_id: this.quoteId }))
            .then(
                (res: any) => {
                    this.quoteInfo = res.data;
                    this.totalBalanceByCredit = this.toFixedValue(this.quoteInfo.total_amount, 2);
                    forEach(this.quoteInfo.m_lines, (item: any) => {
                        if (item.shipment_code == 'PL') {
                            this.pickupService = 'Liftgate';
                        } else if (item.shipment_code == 'DL') {
                            this.deliveryService = 'Liftgate';
                        }
                    });
                    this.totalBalanceByCredit = this.toFixedValue(this.quoteInfo.total_amount, 2);
                    console.log('this.totalBalanceByCredit--', clone(this.totalBalanceByCredit));
                },
                (err: any) => {
                    this.showErrorFun(err.response.data.statusText);
                }
            );
    }

    getWarehouse() {
        if (localStorageUtil.getItemFromStorage('company_id') == '26') {
            this.orderParams.warehouse_id1 = 56011;
        } else {
            this.orderParams.warehouse_id1 = 2809;
        }
    }

    placeOrder(isDraft: Boolean) {
        this.$validator.validateAll().then(res => {
            this.validateErrors(this);
            if (res) {
                if (this.quoteInfo.fk_tms_order_id) {
                    this.err(
                        `Your shipment #.${this.quoteId}." have been saved draft or placed order`
                    );
                } else this.quoteAccept(isDraft);
            }
        });
    }

    toFixedValue(oldNumber: Number | String, setNum: Number | String) {
        let resultValue = oldNumber;
        if (isNumber(oldNumber)) {
            if (isNumber(setNum)) {
                resultValue = round(oldNumber, setNum);
            } else {
                resultValue = round(oldNumber, Number(setNum));
            }
        } else if (isString(oldNumber)) {
            if (isNumber(setNum)) {
                resultValue = round(Number(oldNumber), setNum);
            } else {
                resultValue = round(Number(oldNumber), Number(setNum));
            }
        }
        return resultValue;
    }

    quoteAccept(isDraft: Boolean) {
        if (!this.canPlaceOrder) {
            this.showErrorFun('Quote params error.');
            return;
        }
        if (isDraft) {
            this.orderParams.shipment_is_draft = '1';
        } else {
            delete this.orderParams.shipment_is_draft;
            /* if (!this.acceptService) {
             this.showErrorFun('Please accept Terms of Service first.');
             return;
             }*/
        }
        this.orderParams.request_from = 'clientV2';
        this.orderParams.payMent = this.payMethod.payment_method;
        this.orderParams.pickup_location_id = this.orderParams.pickupLocationId;
        this.orderParams.delivery_location_id = this.orderParams.deliveryLocationId;
        this.orderParams.ltl_client_portal = 1;
        this.orderParams.ltl_client_portal_pu = 1;
        this.orderParams.appointment_date = this.orderParams.appointment_date;
        this.orderParams.appointment_time = this.orderParams.appointment_time;
        this.orderParams.appointment_time_to = this.orderParams.appointment_time_to;
        this.orderParams.input_shipment_ready = this.orderParams.appointment_time;
        this.orderParams.input_shipment_close = this.orderParams.appointment_time_to;
        this.orderParams.role = this.orderParams.role;
        this.orderParams.shipper_contactless_active = this.orderParams.shipper_contactless_active;
        this.orderParams.consignee_contactless_active = this.orderParams.consignee_contactless_active;
        this.orderParams.shipper_contactless_id = this.orderParams.shipper_contactless_id;
        this.orderParams.consignee_contactless_id = this.orderParams.consignee_contactless_id;
        this.orderParams.ltlClientPortal = 1;
        this.orderParams.ltlClientPortalPU = 1;
        this.orderParams.quote_id = this.quoteId;
        this.orderParams.billto_id = this.billToId;
        if (
            this.payMethod &&
            this.payMethod.payment_method &&
            this.payMethod.payment_method == 'Paypal'
        ) {
            this.preisDraft = isDraft;
            this.isPayPal = true;
            this.totalBalanceByCredit = this.toFixedValue(
                (this.quoteInfo.total_amount * 105) / 100,
                2
            );
            return;
        }
        if (this.payMethod && this.payMethod.payment_method) {
            this.orderParams.pay_method_id = this.selectPayMent.paymethod_id;
            this.orderParams.paymethod_id = this.selectPayMent.paymethod_id;
            this.orderParams.billing_city = this.selectPayMent.location_city;
            this.orderParams.billing_state = this.selectPayMent.location_state;
            this.orderParams.billing_zip = this.selectPayMent.zip;
            this.orderParams.billing_street = this.selectPayMent.location_street;
            this.orderParams.billing_street2 = this.selectPayMent.location_street2;
            this.orderParams.account = this.selectPayMent.account;
            this.orderParams.exp_date = this.selectPayMent.exp_date;
            this.orderParams.name_on_card = this.selectPayMent.name_on_card;
            this.orderParams.zip = this.selectPayMent.zip;
            this.orderParams.cv = this.selectPayMent.cv;
        }
        if (
            this.payMethod &&
            this.payMethod.payment_method &&
            this.payMethod.payment_method == 'CC'
        ) {
            this.preisDraft = isDraft;
            this.orderParams.pay_amount = this.toFixedValue(
                (this.quoteInfo.total_amount * 105) / 100,
                2
            );

            this.orderParams.additional_quote_lines = [
                {
                    lane_text: '5% credit surcharge',
                    calc_text: '5% credit surcharge',
                    amount: this.toFixedValue(
                        (this.quoteInfo.total_amount * 105) / 100 - this.quoteInfo.total_amount,
                        2
                    ),
                    type: 'CHARGE-OTHER',
                },
            ];
            tmsServiceBackend.post(`/cp/place/order`, qs.stringify(this.orderParams)).then(
                (res: any) => {
                    let onlineChargeArray = res.data.data;
                    let orderIds = map(onlineChargeArray, 'order_id');
                    this.callbackPlaceOrder(res, orderIds[0]);
                },
                (err: any) => {
                    this.err(err.response.data.message);
                }
            );
            return;
        }
        if (
            this.payMethod &&
            this.payMethod.payment_method &&
            this.payMethod.payment_method == 'ACH'
        ) {
            this.preisDraft = isDraft;
            if (this.orderParams.additional_quote_lines)
                this.$delete(this.orderParams, 'additional_quote_lines');
            this.orderParams.pay_amount = this.toFixedValue(this.quoteInfo.total_amount, 2);
            tmsServiceBackend.post(`/cp/place/order`, qs.stringify(this.orderParams)).then(
                (res: any) => {
                    let onlineChargeArray = res.data.data;
                    let orderIds = map(onlineChargeArray, 'order_id');
                    this.callbackPlaceOrder(res, orderIds[0]);
                },
                (err: any) => {
                    this.err(err.response.data.message);
                }
            );
            return;
        }

        tmsService
            .post(`/write_new/write_tms_quote_accept.php`, qs.stringify(this.orderParams))
            .then(
                (res: any) => {
                    this.callbackPlaceOrder(res);
                },
                (err: any) => {
                    this.err(err.response.data.statusText);
                }
            );
    }

    SaveDraft() {}

    goBackEditPage() {
        this.$router.push({
            name: 'ScheduleApickup',
            params: {
                quoteId: this.quoteId,
            },
        });
    }

    onPlaceOrder() {
        this.$modal.show(this.editProductModal);
    }

    onEditDetals(name: any) {
        this.editDetals[name] = false;
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
            this.tipType = '';
        }, 3000);
    }

    goBolCreatePage() {
        if (!this.orderId) {
            this.showErrorFun('param error.');
            return;
        }
        this.$router.replace({
            name: 'Billoflading',
            params: {
                orderId: this.orderId,
            },
        });
    }

    viewShipmentList() {
        this.$router.push({
            name: 'Shipment',
        });
    }

    addPayMethod() {
        this.editProductModal = 'addPayMethodDom';
        this.$modal.show(this.editProductModal);
    }

    addNewPayment() {
        this.$modal.hide(this.editProductModal);
        this.refreshPaymethodList = true;
    }

    selectPayMethod(item: any) {
        this.selectPayMent = item;
        this.selectPayMent.account = this.selectPayMent.account.replace(/\s+/g, '');
        this.paymentMethodType = item.payment_method;
        this.countAmount();
    }

    countAmount() {
        this.totalBalance = 0;
        forEach(this.list, (item, index) => {
            let perBalance: any = 0;
            if (this.paymentMethodType == 'CC') {
                perBalance = this.toFixedValue((item.balance * 105) / 100, 2);
            } else {
                perBalance = item.balance;
            }
            this.totalBalance += Number(perBalance);
        });
        this.totalBalanceByCredit = this.toFixedValue(this.totalBalance - this.creditAmount, 2);
        this.totalBalance = this.toFixedValue(this.totalBalance, 2);
    }

    setChargeParam() {
        let param: any = {
            invoice_id_ary: [],
            billto_id: this.billToId,
            unis_credit_amount: this.creditAmount,
            apply_amount: this.totalBalanceByCredit,
            pay_method_id: this.payMethod.location_cx1_id,
            additional_quote_lines: [],
            call_from: 'CP',
        };
        forEach(this.list, (item, index) => {
            param.invoice_id_ary.push(item.tms_ar_id);
        });
        forEach(this.list, (item, index) => {
            let params: any = {};
            params.ar_id = item.tms_ar_id;
            if (this.paymentMethodType == 'CC') {
                params.lane_text = 'Transaction fee 5%';
                params.calc_text = 'Transaction fee 5%';
                params.amount = ((item.balance * 105) / 100 - item.balance).toFixed(2);
                param.additional_quote_lines.push(params);
            } else {
                params.amount = 0;
            }
        });
        return param;
    }

    paymentAuthorized(data: any) {}

    paymentCompleted(data: any) {
        this.afterPayPal(data);
        tmsServiceBackend.post(`/cp/place/order/paypal`, qs.stringify(this.orderParams)).then(
            (res: any) => {
                let onlineChargeArray = res.data.data;
                let orderIds = map(onlineChargeArray, 'order_id');
                this.isPayPal = false;
                this.callbackPlaceOrder(res, orderIds[0]);
            },
            (err: any) => {
                this.isPayPal = false;
                this.err(err.response.data.message);
            }
        );
    }

    callbackPlaceOrder(res: any, orderId: any = null) {
        if (res.data == '-2') {
            this.tipType = 'tip-success';
            this.err(`Your shipment #${this.quoteId} have been saved draft or placed order.`);
        } else if (res.data.error_text) {
            this.err(res.data.error_text);
        } else {
            if (this.preisDraft) {
                this.editProductModal = 'saveDraftShow';
                this.$modal.show(this.editProductModal);
            } else {
                this.$router.replace({
                    name: 'ShipmentCconfirmation',
                    params: {
                        id: orderId ? orderId : res.data.order_id,
                        quoteId: this.quoteId,
                    },
                });
            }
            this.orderId = orderId ? orderId : res.data.order_id;
            localStorageUtil.removeItemFromStorage('quoteData_' + this.quoteId);
        }
    }

    paymentCancelled(data: any) {}

    afterPayPal(data: any) {
        this.orderParams['pay_id'] = data.id;
        this.orderParams['paypal_account'] = data.payer.payer_info.email;
        this.orderParams['call_from'] = 'CP';
        this.orderParams['pay_amount'] = this.toFixedValue(
            (this.quoteInfo.total_amount * 105) / 100,
            2
        );
        this.orderParams.payMent = this.payMethod.payment_method;
        this.orderParams.pickup_location_id = this.orderParams.pickupLocationId;
        this.orderParams.delivery_location_id = this.orderParams.deliveryLocationId;
        this.orderParams.ltl_client_portal = 1;
        this.orderParams.ltl_client_portal_pu = 1;
        this.orderParams.appointment_date = this.orderParams.appointment_date;
        this.orderParams.appointment_time = this.orderParams.appointment_time;
        this.orderParams.appointment_time_to = this.orderParams.appointment_time_to;
        this.orderParams.role = this.orderParams.role;
        this.orderParams.shipper_contactless_active = this.orderParams.shipper_contactless_active;
        this.orderParams.consignee_contactless_active = this.orderParams.consignee_contactless_active;
        this.orderParams.shipper_contactless_id = this.orderParams.shipper_contactless_id;
        this.orderParams.consignee_contactless_id = this.orderParams.consignee_contactless_id;
        this.orderParams.ltlClientPortal = 1;
        this.orderParams.ltlClientPortalPU = 1;
        this.orderParams.quote_id = this.quoteId;
        this.orderParams.billto_id = this.billToId;
        this.orderParams.billing_city = data.payer.payer_info.shipping_address.city;
        this.orderParams.billing_state = data.payer.payer_info.shipping_address.state;
        this.orderParams.billing_zip = data.payer.payer_info.shipping_address.postal_code;
        this.orderParams.billing_street = data.payer.payer_info.shipping_address.line1;
        this.orderParams.billing_country = data.payer.payer_info.shipping_address.country_code;

        /*   this.orderParams.billing_city = this.shipperAddress.location_city;
          this.orderParams.billing_state = this.shipperAddress.location_state;
          this.orderParams.billing_zip = this.shipperAddress.reditCardZip;
          this.orderParams.billing_street = this.shipperAddress.location_street;
          this.orderParams.billing_street2 = this.shipperAddress.location_street2; */
        /*{
            "status": -1,
            "status_code": "invalid_arguments",
            "message": {
            "pickup_location_id": [
                "The pickup location id field is required."
            ],
                "delivery_location_id": [
                "The delivery location id field is required."
            ]
        },
            "trace_request_id": null
        }*/
        this.orderParams['additional_quote_lines'] = [
            {
                lane_text: 'Transaction fee 5%',
                calc_text: 'Transaction fee 5%',
                amount: this.toFixedValue(
                    (this.quoteInfo.total_amount * 105) / 100 - this.quoteInfo.total_amount,
                    2
                ),
                type: 'CHARGE-OTHER',
            },
        ];
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        localStorage.removeItem(util.Base64EncodetoString('AddPayMents'));
        next();
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/reviewPickupRequest/index.ts